import CalloutGridCard from '@repo/ui/src/components/CalloutGridCard';
import { HorizontalAlignmentEnum, VerticalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { classNames } from '@repo/ui/src/utils/classNames';
import { ImageProps, MediaType, MetaProps, ToutContentProps } from '@repo/ui/src/types';

interface CalloutGridProps {
  cards: Array<{
    _meta: MetaProps;
    background: MediaType;
    backgroundImage: ImageProps;
    image: ImageProps;
    horizontalAlignment: HorizontalAlignmentEnum;
    verticalAlignment: VerticalAlignmentEnum;
    layout: string;
    toutContent: ToutContentProps;
  }>;
  threeAcross: boolean;
  backgroundColor: 'None' | 'Dark' | 'Light';
  _testID?: string;
}

const backgroundColors = {
  None: 'tw-bg-white',
  Dark: 'tw-bg-neutral-600',
  Light: 'tw-bg-warm-200',
};

const cardStyles = {
  'Full Width':
    'tw-min-h-fit tw-max-h-[1000px] tw-h-[clamp(0px,160vw,80vh)] md:tw-h-[clamp(0px,52vw,80vh)] md:tw-col-span-2',
  'Half Width': 'tw-aspect-[5/8] md:tw-max-h-[560px] md:tw-w-full',
  Split: 'md:tw-col-span-2',
};

const CalloutGrid = ({ cards, _testID, threeAcross, backgroundColor }: CalloutGridProps) => (
  <section
    className={classNames('tw-bg-speckle tw-bg-fixed', backgroundColors[backgroundColor])}
    data-testid="callout-grid-section"
  >
    <ul
      className={classNames(
        'tw-list-none tw-m-0 tw-p-6 tw-grid tw-gap-6 md:tw-grid-cols-2 md:tw-p-12 tw-items-stretch',
        threeAcross ? 'md:tw-grid-cols-3' : 'md:tw-grid-cols-2',
      )}
    >
      {cards.map((card, index) => (
        <li
          key={card?._meta?.deliveryId}
          className={classNames(
            'tw-max-w-full tw-grid tw-h-full',
            !threeAcross && cardStyles[card.layout as keyof typeof cardStyles],
          )}
          data-testid={`${_testID}-${index}`}
        >
          <CalloutGridCard {...card} _testID={_testID} index={index} threeAcross={threeAcross} />
        </li>
      ))}
    </ul>
  </section>
);

export default CalloutGrid;
